/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadsFindAllResponse } from './LeadsFindAllResponse';
import {
    LeadsFindAllResponseFromJSON,
    LeadsFindAllResponseFromJSONTyped,
    LeadsFindAllResponseToJSON,
    LeadsFindAllResponseToJSONTyped,
} from './LeadsFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllLeads200Response
 */
export interface FindAllLeads200Response {
    /**
     * 
     */
    data?: LeadsFindAllResponse;
}

/**
 * Check if a given object implements the FindAllLeads200Response interface.
 */
export function instanceOfFindAllLeads200Response(value: object): value is FindAllLeads200Response {
    return true;
}

export function FindAllLeads200ResponseFromJSON(json: any): FindAllLeads200Response {
    return FindAllLeads200ResponseFromJSONTyped(json, false);
}

export function FindAllLeads200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeads200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadsFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllLeads200ResponseToJSON(json: any): FindAllLeads200Response {
    return FindAllLeads200ResponseToJSONTyped(json, false);
}

export function FindAllLeads200ResponseToJSONTyped(value?: FindAllLeads200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadsFindAllResponseToJSON(value['data']),
    };
}

